<template>
<modal name="athlete-dialog"
  :adaptive="true"
  :scrollable="true"
  height="auto">
  <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
    <el-button @click="closeAthleteDialog"
      icon="el-icon-circle-close-outline"
      style="font-size: 2rem;"
      type="text"></el-button>
  </div>
  <div class="setting" v-if="permissionType == 1">
    <div class="setting-item" style="text-align:center;">
      <p style="font-size: 150%;">ダウンロードが完了しました!</p>
      <p style="font-size: 140%;">【就職活動も終盤戦】</p>
      <p style="font-size: 140%;">最短14日で内定獲得!</p>
      <p style="font-size: 140%;">今作成した履歴書を手に、</p>
      <p style="font-size: 140%;">就職アドバイザーが<span style="color: #0000ff;">就職支援</span>や、</p>
      <p style="font-size: 140%;"><span style="color: #0000ff;">就職に役立つ情報提供</span>をしていきます。</p>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/salplus-agent-yagish-logo.png" style="width:100%" >
        </p>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;">ご同意いただいた方には追って連絡がいき</p>
        <p style="font-size: 140%;">ますので、ご確認お願いいたします！</p>
      </div>
      <p>
        Yagishの<router-link id="footer-link-terms" :to="{name: 'termsPage'}" target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{name: 'policyPage'}" target="_blank">個人情報保護方針</router-link><br/>
         ㈱アド・トップの<a href="https://adtop-web.com/saiplus/agent/careerup/tos.html" target="_blank">利用規約</a>、<a href="https://adtop-web.com/privacypolicy.html" target="_blank">個人情報保護方針</a><br/>
      </p>
    </div>
    <div style="display: inline-block;min-width: 100%;text-align:center;">
      <p style="font-size: 140%;"> 
        <img src="/static/renew_img/check_icon.png" style="width:40px" >規約に同意してさっそく就職相談を希望する
      </p>
    </div>
    <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="false">
      <p style="font-size: 140%;"> 
        <el-checkbox v-model="isAgree" style="-moz-transform:	scale(1.4);-webkit-transform:	scale(1.4);transform:		scale(1.4);">規約に同意して無料相談や<br>求人受取、会員登録を希望する</el-checkbox>
      </p>
      <br/>
    </div>
    <div class="text-center" style="padding:10px">
      <el-button id="send-adtop-pdf" type="success" v-if="isAthleteSended == false"
      style="background-color:#048573;border-color:#048573;font-size: 140%;"
        @click="$eventHub.$emit('send-athlete-consult', 23);">23卒の方はこちら</el-button>
      <el-button id="send-adtop-pdf" type="success" v-if="isAthleteSended == true"
      style="background-color:#0F9934;border-color:#0F9934;"
        @click="closeAthleteDialog();">送信しました</el-button>
      <br/>
    </div>
    <div class="text-center" style="padding:10px">
      <el-button id="send-adtop-pdf" type="success" v-if="isAthleteSended == false"
      style="background-color:#B9F6EE;border-color:#B9F6EE;font-size: 140%;color:#000000;"
        @click="$eventHub.$emit('send-athlete-consult', 24);">24卒の方はこちら</el-button>
      <el-button id="send-adtop-pdf" type="success" v-if="isAthleteSended == true"
      style="background-color:#0F9934;border-color:#0F9934;"
        @click="closeAthleteDialog();">送信しました</el-button>
      <br/>
    </div>
  </div>
</modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
export default {
  components: {
  },
  data: function () {
    return {
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      previewHtml: '',
      permissionType: 0,
      isAthleteSended:false,
      fullscreenLoading:false,
      athleteUnivId:'',
      username:'',
      isAgree:true
    }
  },
  created : function(){
    const app = this
    this.$iterateStorage(function (value, key, iterationNumber) {
        //console.log all the kay/value pairs
        if (key === 'basicData') {
          app.username = value.lastName + '_' + value.firstName
        }
    }, function (err) {
        if (!err) {
            console.log('Iteration has completed');
        }
    })
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      const formData = new FormData()
      formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('pdf_option', 'A4')
      return formData
    }
  },
  methods: {
    openAthleteDialog: function (id, html) {
      this.formatid = id
      this.previewHtml = html.$el.innerHTML
      this.$modal.show('athlete-dialog')
      this.clearLocalStorageConfirmVisible = false
      this.athleteUnivId  = this.$cookies.get('_YAGISH_ATHLETE_UNIVID')
      if (this.athleteUnivId == 'meidai') {
        this.permissionType = 1
      } else if (this.athleteUnivId == 'tokai') {
        this.permissionType = 1
      } else if (this.athleteUnivId == 'nittai') {
        this.permissionType = 1
      }


      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('dialog_name', 'athlete_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('site_flag', 'd')
      formData.append('app_flag', '')
      const app = this
      this.$axios.post(this.$varuna.endPoints.displayDialog, formData, {timeout: 60000})
      this.$iterateStorage(function (value, key, iterationNumber) {
          //console.log all the kay/value pairs
          if (key === 'basicData') {
            app.username = value.lastName + '_' + value.firstName
          }
      }, function (err) {
          if (!err) {
              console.log('Iteration has completed');
          }
      })
    },
    closeAthleteDialog: function () {
      this.$modal.hide('athlete-dialog')
      this.clearLocalStorageConfirmVisible = false
    },
    confirmWin: function () {
      confirm('応募するデータを送信します。よろしいでしょうか。')
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.formatid}${dateString}.${ext}`
    },
    sendAthleteConsult: async function (gradeNumb) {
      console.error(gradeNumb)
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', '')
      formData.append('contents_id', process.env.VUE_APP_ADTOP_ATHLETE_CONTENTS_ID)
      formData.append('dialog_name', 'athlete_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('reqflg', '2')
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.sendAthlete, formData, {timeout: 60000})
        .then(function (response) {
          app.isAthleteSended = true
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('send-athlete-consult', this.sendAthleteConsult)
    this.$eventHub.$on('open-athlete-dialog', this.openAthleteDialog)
    this.$eventHub.$on('popstate', this.closeAthleteDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('send-athlete-consult', this.sendAthleteConsult)
    this.$eventHub.$off('open-athlete-dialog', this.openAthleteDialog)
    this.$eventHub.$off('popstate', this.closeAthleteDialog)
  }
}
</script>
